import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'src/app/models/company.model';
import { HeaderStatus } from 'src/app/models/header-status.model';
import { SignatureRequestService } from 'src/app/services/signature-request.service';
import { SignaturesHeaderService } from 'src/app/services/signatures-header.service';
@Component({
  selector: 'app-signatures-wrapper',
  templateUrl: './signatures-wrapper.component.html',
  styleUrls: ['./signatures-wrapper.component.sass']
})
export class SignaturesWrapperComponent implements OnInit {
  header_status:HeaderStatusCustom = {
    opened: false,
    bold_text: null,
    text: null,
    svg: null
  };

  svg:SafeHtml = null as any;

  public auth_step:0|1|2|3 = 0;
  public company:Company = null as any;

  public availableLanguages: { code: string; flag: string; }[] = [];
  selectedLanguage: any;


  constructor(private header:SignaturesHeaderService,
              private signature_request:SignatureRequestService,
              private sanitizer: DomSanitizer,
              private readonly translate: TranslateService) {
    this.availableLanguages = this.translate.getLangs().map(lang => {
      return {code: lang, flag: `/assets/img/flags/${lang}.png`}
    });
  }

  ngOnInit(): void {
    this.initHeader();
    this.listenAuthSteps();
    this.listenSignatureRequest();
    this.listenSignatureRequestUuidQueryParam();

  }

  private listenSignatureRequestUuidQueryParam() {
    const signature_uuid = (new URL(window.location.href)).searchParams.get("signature_uuid");
    if(signature_uuid!=null) {
      this.signature_request.obtainSignatureRequestLanguage(signature_uuid);

      this.signature_request.signature_request_language.subscribe(
        data => {
          this.selectedLanguage = this.availableLanguages.find(language => language.code === data);
        }
      );
    }
  }

  private initHeader() {
    this.header.currentHeaderStatus.subscribe(
      status => {
        let s:HeaderStatusCustom = status;
        if(status.svg!=null) {
          this.svg = this.sanitizer.bypassSecurityTrustHtml(status.svg);
        }
        else {
          this.svg = null as any;
        }

        this.header_status = s;
      }
    );
  }

  private listenAuthSteps() {
    this.header.loadingBarStep.subscribe(
      data => {
        this.auth_step = data;
      }
    );
  }

  private listenSignatureRequest() {
    this.signature_request.signature_request.subscribe(
      data => {
      }
    );
    this.signature_request.company.subscribe(
      data => {
        this.company = data;
      }
    );
  }

  public changeLanguage(event: any) {
    if(event.value.code) this.translate.use(event.value.code);
  }

}

interface HeaderStatusCustom extends Omit<HeaderStatus, 'svg'> {
  svg:SafeHtml|null;
}
